import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Longdash } from '~/utils';

interface Props {
  country: string | undefined;
}

const CountryField: FC<Props> = (props) => {
  const { country } = props;
  const [t] = useTranslation('countries');

  return <div>{country ? t(country) : Longdash}</div>;
};

export default CountryField;
